import { Box } from "@chakra-ui/react";
import MarkDownRender from "../MarkDownRender";
import { ReactElement } from "react";

export type IDefinationProps = {
  content: string;
  handleClick?: () => void;
  sections?: ReactElement[][];
};

const Definition = ({ content, handleClick, sections }: IDefinationProps) => {
  return (
    <Box px={"1rem"}>
      <Box
        onClick={handleClick}
        py={".5rem"}
        px={"1rem"}
        border={"1px solid"}
        borderColor={"neutral.800"}
        borderRadius={"1rem"}
      >
        {sections ? (
          sections.map((element, index) => (
            <Box key={index}>
              {element.map((e, idx) => (
                <Box key={idx}>{e}</Box>
              ))}
            </Box>
          ))
        ) : (
          <MarkDownRender content={content} />
        )}
      </Box>
    </Box>
  );
};

export default Definition;
